export const TemplatedTerms = {
  IF_OMNI: '#IF_OMNI#',
};

export const TemplateReplacementInstructions = new Map([
  [TemplatedTerms.IF_OMNI, 'If Omni'],
]);
